import React, { useState } from 'react';
import { Box, Divider, Typography } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import CloseButton from 'components/CustomButtons/CloseButton';
import Loader from 'components/Loader';
import GoErpApp from 'components/GoErpApp/GoErpApp';
import { pickupOrder } from 'actions/sales';
import { closeModalPage } from 'actions/ModalPage/closeModalPage';
import * as saleApi from 'services/ErplyAPI/sales';
import { addError } from 'actions/Error';

interface Props {
  documentID: number;
  onClose(): void;
}
const SPLIT_ORDER_PAGE = 'split-order-pos-page';

function OrderSplittingForm({ documentID, onClose }: Props) {
  const dispatch = useDispatch();

  const { t } = useTranslation('order');

  const [loading, setLoading] = useState(false);

  async function messageHandler(messageEvent: MessageEvent) {
    const message = messageEvent?.data;
    if (!message) return;
    if (message.type === 'SPLIT_DOCUMENT' && message.payload?.invoiceId) {
      try {
        const [splitOrder] = await saleApi.getSalesDocuments({
          id: message.payload.invoiceId,
        });
        if (!splitOrder) {
          throw new Error('noDocFound');
        }
        dispatch(closeModalPage());
        await dispatch(pickupOrder(splitOrder));
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Error while retrieving newly split order', e);
        const suffix = e.message === 'noDocFound' ? 'notFound' : 'infoNotSet';
        dispatch(addError(t('alerts.splitOrderPickup', { context: suffix })));
      }
    }
  }

  return (
    <div data-testid="OrderSplittingForm" style={{ maxWidth: '1400px' }}>
      <Box display="flex" alignItems="center" padding="1rem">
        <Typography variant="h5">{t('titles.splitForm')}</Typography>
        <Box flexGrow={1} />
        <CloseButton action={onClose} />
      </Box>
      <Divider />
      <Box>
        <Loader show={loading} block>
          <GoErpApp
            title={t('titles.splitForm')}
            url={`/${SPLIT_ORDER_PAGE}?invoiceId=${documentID}`}
            onStartLoading={() => setLoading(true)}
            onLoad={() => {
              setLoading(false);
            }}
            onMessage={messageHandler}
            iframeProps={{
              style: {
                width: '100%',
                height: 'calc(100vh - 115px)',
              },
            }}
          />
        </Loader>
      </Box>
    </div>
  );
}

export default OrderSplittingForm;
